import { removeTrapFocus, setTrapFocus } from '@/utils/helpers';

export function useTrapFocus() {
  const trapFocusElements: HTMLElement[] = [];

  function set(list: (Node | HTMLElement)[]) {
    trapFocusElements.push(...setTrapFocus(list));
  }

  function unset() {
    if (trapFocusElements.length) {
      removeTrapFocus(trapFocusElements);
      trapFocusElements.length = 0;
    }
  }

  onBeforeUnmount(() => unset());

  return {
    set,
    unset,
  };
}
